import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M803.534 403.174c12.79-13.712 12.074-35.304-1.74-48.095-13.098-12.177-33.36-12.177-46.355 0L512.82 597.598 270.3 355.079c-12.79-13.712-34.28-14.53-48.094-1.74-13.712 12.792-14.53 34.28-1.74 48.095 0.512 0.614 1.126 1.126 1.74 1.74l266.565 266.668c13.303 13.302 34.792 13.302 48.095 0l266.668-266.668z\" p-id=\"1378\" fill=\"#565860\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/down.svg
// module id = LHwD
// module chunks = 152